const isCourier = window.location.pathname.includes('/courier')

let serverUrl = ''
const hostname = window.location.hostname
switch (hostname) {
  case 'm.ishansong.com':
    serverUrl = 'https://beidou.ishansong.com/sa'
    break
  default:
    if (hostname.includes('astable')) {
      serverUrl = 'http://beidou-astable.bingex.com/sa'
    } else if (hostname.includes('bstable')) {
      serverUrl = 'http://beidou-bstable.bingex.com/sa'
    } else if (hostname.includes('cstable')) {
      serverUrl = 'http://beidou-cstable.bingex.com/sa'
    } else {
      serverUrl = 'http://beidou-dstable.bingex.com/sa'
    }
    break
}

(function (para) {
  if (typeof (window.bdDataAnalytic) !== 'undefined') {
    return false
  }
  window.bdDataAnalytic = para.name
  window[para.name] = {
    para: para
  }
})({
  platform: isCourier ? '闪送员版M站' : '用户版M站',
  use_app_track: true, // 是否使用app端上报，视项目而定
  name: 'bd',
  project: isCourier ? 'pj_courier' : 'pj_user',
  server_url: serverUrl,
  heatmap: {}
})
